<template>
  <section class="pilots">
    <h2 class="section-title">
      Piloten
      <span class="material-icons"> flight_takeoff </span>
    </h2>
    <div v-if="flightLog.pilotLogs.length" >
      <div v-for="pilotLog in flightLog.pilotLogs" :key="pilotLog.id" class="pilot-log">
        <div class="pilot-name">{{pilotLog.user.firstName}} {{pilotLog.user.lastName}}</div>
        <!-- <div class="material-div">
          <span class="material-icons"> vaccines </span>
        </div> -->
<!--        <img v-if="pilotLog.user.unlimited"
          class="status-icon"
          src="../assets/Vaccines.svg"
          alt="Test"
        />
        <img v-else
          class="status-icon"
          src="../assets/Vaccines-gray.svg"
          alt="Test"
        /> -->

        <img v-if="pilotLog.twoPointFourGHz"
          class="status-icon"
          src="../assets/Frequency24GHzV2.svg"
          alt="Test"
        />
        <img v-else
          class="status-icon"
          src="../assets/Frequency24GHzV2-gray.svg"
          alt="Test"
        />

        <img v-if="pilotLog.thirtyFiveMHz"
          class="status-icon"
          src="../assets/Frequency35MHz.svg"
          alt="Test"
        />
        <img v-else
          class="status-icon"
          src="../assets/Frequency35MHz-gray.svg"
          alt="Test"
        />
        
        <img v-if="pilotLog.belowFiveKG"
          class="status-icon"
          src="../assets/LighterThan5kg.svg"
          alt="Test"
        />
        <img v-else
          class="status-icon"
          src="../assets/LighterThan5kg-gray.svg"
          alt="Test"
        />

        <img v-if="pilotLog.aboveFiveKG"
          class="status-icon"
          src="../assets/HeavierThan5kg.svg"
          alt="Test"
        />
        <img v-else
          class="status-icon"
          src="../assets/HeavierThan5kg-gray.svg"
          alt="Test"
        />

        <div class="time">{{pilotLog.startTime.substring(11,16)}}</div>
        <div class="to">-</div>
        <div v-if="pilotLog.endTime" class="time">{{pilotLog.endTime.substring(11,16)}}</div>
        <div v-else class="time">--:--</div>
      </div>
    </div>
    <div v-else>Heute sind noch keine Piloten eingetragen.</div>
    
  </section>
</template>

<script>
export default {
  name: "PilotPanel",
  props: ['flightLog']
};
</script>

<style scoped>
.pilots {
  background: #fff;
  margin: 0;
}

.section-title {
  display: inline-block;
  margin: 20px 0;
}

.pilot-log {
  border: 2px solid green;
  margin: 8px 8px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
}

.pilot-name {
  min-width: 110px;
  max-width: 110px;
  padding: 0 0 0 10px;
  text-align: left;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
}

.status-icon {
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0px 3px;
  border-right: 1px solid darkgray;
}
.material-icons {
  /* display:inline-block; */
  color: green;
  padding: 0px 1px;
  font-size: 24px;
  /* border-right: 1px solid darkgray; */
  line-height: 30px;
}

.material-div {
  height: 30px;
}

.time {
  /* width:50px; */
  font-size: 16px;
  display: inline-block;
  padding: 0 2px;
}

.to {
  display: inline-block;
  font-weight: bold;
  /* padding:0 2px; */
}

</style>